import FadeInSection from '../../../components/feature/FadeInSection';

const LINE_URL = 'https://lin.ee/PNbhQI0';

export default function CTASection() {
  return (
    <section
      className="section-padding"
      style={{ background: 'linear-gradient(135deg, #e8934e 0%, #d4a574 100%)' }}
    >
      <div className="content-width">
        <FadeInSection className="text-center mb-8 md:mb-14">
          <h2 className="text-white mb-3 md:mb-4">お問い合わせはこちら</h2>
          <p className="text-white/90" style={{ fontSize: 'clamp(14px, 2vw, 18px)' }}>
            まずはお気軽にご連絡ください。無料相談受付中です。
          </p>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
          {/* Phone */}
          <FadeInSection delay={0}>
            <a
              href="tel:03-4500-8399"
              className="block p-4 md:p-8 rounded-xl text-center hover:scale-[1.02] transition-transform"
              style={{ background: 'rgba(255,255,255,0.95)' }}
            >
              <div
                className="mx-auto mb-3 md:mb-4 flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full"
                style={{ background: '#fff8f2' }}
              >
                <span className="flex items-center justify-center w-7 h-7 md:w-9 md:h-9">
                  <i className="ri-phone-line text-[#e8934e] text-2xl md:text-3xl"></i>
                </span>
              </div>
              <h3 style={{ color: '#8b4513', marginBottom: '6px', fontSize: 'clamp(13px, 2vw, 18px)' }}>お電話でのご相談</h3>
              <p style={{ color: '#8b4513', fontSize: 'clamp(18px, 3.5vw, 26px)', fontWeight: '700', letterSpacing: '0.05em' }}>
                03-4500-8399
              </p>
              <p style={{ color: '#6b5a4e', fontSize: '12px', marginTop: '4px' }}>
                受付時間 10:00〜18:00
              </p>
            </a>
          </FadeInSection>

          {/* LINE */}
          <FadeInSection delay={120}>
            <a
              href={LINE_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="block p-4 md:p-8 rounded-xl text-center hover:scale-[1.02] transition-transform"
              style={{ background: 'rgba(255,255,255,0.95)' }}
            >
              <div
                className="mx-auto mb-3 md:mb-4 flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full"
                style={{ background: '#f0fdf4' }}
              >
                <span className="flex items-center justify-center w-7 h-7 md:w-9 md:h-9">
                  <i className="ri-line-fill text-[#06C755] text-2xl md:text-3xl"></i>
                </span>
              </div>
              <h3 style={{ color: '#8b4513', marginBottom: '6px', fontSize: 'clamp(13px, 2vw, 18px)' }}>LINEで相談する</h3>
              <p style={{ color: '#06C755', fontSize: 'clamp(14px, 2.5vw, 20px)', fontWeight: '700' }}>LINE友だち追加</p>
              <p style={{ color: '#6b5a4e', fontSize: '12px', marginTop: '4px' }}>
                チャットでいつでもご質問いただけます
              </p>
            </a>
          </FadeInSection>

          {/* Form */}
          <FadeInSection delay={240}>
            <a
              href="/contact"
              className="block p-4 md:p-8 rounded-xl text-center hover:scale-[1.02] transition-transform"
              style={{ background: 'rgba(255,255,255,0.95)' }}
            >
              <div
                className="mx-auto mb-3 md:mb-4 flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full"
                style={{ background: '#f2f8f4' }}
              >
                <span className="flex items-center justify-center w-7 h-7 md:w-9 md:h-9">
                  <i className="ri-mail-line text-[#5a9e6f] text-2xl md:text-3xl"></i>
                </span>
              </div>
              <h3 style={{ color: '#8b4513', marginBottom: '6px', fontSize: 'clamp(13px, 2vw, 18px)' }}>フォームでのお問い合わせ</h3>
              <p style={{ color: '#5a9e6f', fontSize: 'clamp(14px, 2.5vw, 20px)', fontWeight: '700' }}>お問い合わせフォーム</p>
              <p style={{ color: '#6b5a4e', fontSize: '12px', marginTop: '4px' }}>
                24時間いつでも送信できます
              </p>
            </a>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
}
